import React, { useReducer, createContext, useContext } from 'react';

// Create context
export const StoreContext = createContext();
StoreContext.displayName = 'StoreContext';

// Initial state
const initialState = {
  navOpenState: '',
  alerts: [],
  location: '',
  currentPage: '',
};

// Reducer
function storeReducer(state, action) {
  switch (action.type) {
    case 'SET_NAV_STATE':
      return {
        ...state,
        navOpenState: action.state,
      };

    case 'PUSH_ALERT':
      return {
        ...state,
        alerts: [...state.alerts, { id: Date.now(), ...action.alert }],
      };

    case 'DISMISS_ALERT':
      return {
        ...state,
        alerts: state.alerts.filter((alert) => alert.id !== action.id),
      };

    case 'SET_LOCATION':
      return {
        ...state,
        location: action.location,
      };

    case 'SET_CURRENT_PAGE':
      return {
        ...state,
        currentPage: action.currentPage,
      };

    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
}

// Action creators
export const setNavState = (dispatch, state) =>
  dispatch({ type: 'SET_NAV_STATE', state });

export const setLocation = (dispatch, location) =>
  dispatch({ type: 'SET_LOCATION', location });

export const setCurrentPage = (dispatch, currentPage) =>
  dispatch({ type: 'SET_CURRENT_PAGE', currentPage });

export const pushAlert = (dispatch, alert) => {
  const id = Date.now();
  dispatch({ type: 'PUSH_ALERT', alert: { id, ...alert } });

  // Auto-dismiss after 5 seconds
  setTimeout(() => {
    dispatch({ type: 'DISMISS_ALERT', id });
  }, 5000);
};

export const dismissAlert = (dispatch, id) =>
  dispatch({ type: 'DISMISS_ALERT', id });

// Store provider
function StoreProvider(props) {
  const [store, dispatch] = useReducer(storeReducer, initialState);
  const value = [store, dispatch];

  return <StoreContext.Provider value={value} {...props} />;
}

// Custom hook to use the store
export function useStore() {
  const context = useContext(StoreContext);
  if (!context) {
    throw new Error('useStore must be used within a StoreProvider');
  }
  return context;
}

// Main wrapper
function Store({ children }) {
  return <StoreProvider>{children}</StoreProvider>;
}

export default Store;
